import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import bigLogoAlconostMt from '../../assets/big_logo_alconost_mt.svg';

const Footer = () => {
  const [open, setOpen] = useState(false);
  return (
    <footer className="bg-gray-50 border-t text-gray-600 text-sm">
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 md:gap-0">
        
        <div className="flex flex-col items-start md:items-start text-left">
          <div className="flex flex-wrap items-center">
            <img
              src={bigLogoAlconostMt}
              alt="Alconost MT Logo"
              className="w-[124px] h-[24px] md:h-6 md:w-auto mr-1"
            />
            <span>
              is provided by
              <a
                href="https://alconost.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#3B82F6] hover:underline mx-1"
              >
                Alconost
              </a>
              the leading localization services provider
            </span>
          </div>

          <p className="text-sm text-gray-500 mt-4">
            © {new Date().getFullYear()} Alconost. All rights reserved.
          </p>
        </div>

        <div className="flex flex-row items-start md:items-center gap-2 md:gap-6">
          <button
            className="text-[#6B7280] hover:text-gray-900 underline-offset-2 hover:underline bg-transparent border-none outline-none cursor-pointer"
            onClick={() => setOpen(true)}
          >
            Data Protection and Privacy Policy
          </button>
          <a
            href="mailto:mt-metrics@alconost.com"
            className="text-[#6B7280] hover:text-gray-900"
          >
            Contact
          </a>
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-full max-w-[800px] max-h-[1080px] h-[calc(100vh-160px)] overflow-hidden gap-0">
          <DialogHeader className="!space-y-0 h-[32px] p-0 mb-6">
            <DialogTitle className="text-2xl font-bold">
              How is my data protected when using Alconost.MT/Metrics?
            </DialogTitle>
          </DialogHeader>
          <div className="overflow-auto">
            <div className="py-0 text-[#020817]">
              <div className="mb-6">
                <p className="text-lg font-medium mb-3">Primary Coverage:</p>
                <span>Your use of Alconost.MT/Metrics is governed by Alconost’s Terms of Service and Privacy Policy, which outline our commitments to data protection and user privacy.</span>
              </div>
              <div className="mb-6">
                <p className="text-lg font-medium mb-3">Data Handling:</p>
                <span>The text you submit is used to compute automated quality metrics. Do not submit confidential, proprietary, or sensitive personal information through the tool.</span>
              </div>
              <div className="mb-6">
                <p className="text-lg font-medium mb-3">Recommendations:</p>
                <ul className="list-disc pl-6 mt-2">
                  <li className='mb-3'>Do not submit confidential, proprietary, or sensitive personal information through the tool</li>
                  <li className='mb-3'>For highly sensitive content, consider using our traditional human-only translation services</li>
                  <li>This tool is intended for testing and analysis purposes</li>
                </ul>
              </div>
              <div className="mb-6">
              <p className="text-lg font-medium mb-3">Contact:</p>
                <span>For specific questions about data handling or privacy concerns,<br/>please contact us at <a href="mailto:mt-metrics@alconost.com" className="underline">mt-metrics@alconost.com</a>.</span>
              </div>
              <div className="text-[#6B7280]">
                For complete terms and privacy information, please review our full
                <a href="https://alconost.com/en/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline ml-1">Privacy Policy</a>  and
                <a href="https://alconost.com/en/legal/terms-of-service" target="_blank" rel="noopener noreferrer" className="underline ml-1">Terms of Service</a>.
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  </footer>
  );
};

export default Footer; 